import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.reset();
  }

  inputLength(event) {
    var element = event.target;
    var charsLeft = $(element).prop("maxLength") - $(element).val().length;
    $(event.params.indicator).html(charsLeft);
  }

  submitParentForm(event) {
   // console.log("HELP!");
    var element = event.target;
   // $(element).closest("form")[0].requestSubmit();
    Turbo.navigator.submitForm($(element).closest("form")[0])
  }

    submitParentFormNoTurbo(event) {
   // console.log("HELP!");
    var element = event.target;
   $(element).closest("form")[0].requestSubmit();
  //  Turbo.navigator.submitForm($(element).closest("form")[0])
  }
}
